<div class="data-view">
  <!-- Table View -->
  @if (isTableView() && hasRowsContent()) {
    <div class="data-view__table-container">
      <!-- Empty state -->
      @if (
        !dataSource().loading &&
        dataSource().items.length === 0 &&
        (dataSource().hasEverLoaded ?? false)
      ) {
        <umss-empty-state
          title="No results found."
          description="Try adjusting your filters or check back later."
          iconName="phosphorMagnifyingGlass"
          [showButton]="false"
        />
      }

      <!-- Table (always rendered when not empty or loading; skeletons replace rows during load) -->
      @if (dataSource().loading || dataSource().items.length > 0) {
        <umss-table density="Regular" [fullWidth]="true" [bordered]="true">
          <!-- Generated header from column definitions -->
          <ng-container umssTableHeader>
            <tr>
              @for (col of visibleColumns(); track col.key) {
                <th
                  [class]="'col-' + col.key"
                  [class.col--sortable]="col.sortable"
                  [class.col--fixed]="col.fixed"
                  (click)="col.sortable && onSort(col.key)"
                >
                  <span>{{ col.name }}</span>
                  @if (col.sortable && sortColumn() === col.key) {
                    <span [class]="getSortIconClass(col.key)">
                      {{ sortDirection() === 'asc' ? '↑' : '↓' }}
                    </span>
                  }
                </th>
              }
            </tr>
          </ng-container>

          <ng-container umssTableBody>
            @if (dataSource().loading) {
              <!-- Skeleton rows while loading -->
              @for (row of skeletonRows(); track $index) {
                <tr class="data-view__skeleton-row">
                  @for (col of visibleColumns(); track col.key) {
                    <td [class]="'col-' + col.key">
                      <umss-skeleton
                        variant="Line"
                        [styles]="{
                          width: '80%',
                          height: '28px',
                          borderRadius: '4px'
                        }"
                      />
                    </td>
                  }
                </tr>
              }
            } @else {
              <!-- Real rows projected from the parent via [umssDataViewRows] -->
              <ng-content select="[umssDataViewRows]" />
            }
          </ng-container>
        </umss-table>
      }
    </div>
  }

  <!-- Card Grid View -->
  @if (isGridView() && hasCardsContent()) {
    <!-- Empty state -->
    @if (
      !dataSource().loading &&
      dataSource().items.length === 0 &&
      (dataSource().hasEverLoaded ?? false)
    ) {
      <umss-empty-state
        title="No results found."
        description="Try adjusting your filters or check back later."
        iconName="phosphorMagnifyingGlass"
        [showButton]="false"
      />
    }

    <div class="cards-grid">
      @if (dataSource().loading) {
        <!-- Skeleton cards while loading -->
        @for (row of skeletonRows(); track $index) {
          <umss-skeleton
            variant="Object"
            [styles]="{ height: '220px', borderRadius: '8px' }"
          />
        }
      } @else {
        <ng-content select="[umssDataViewCards]" />
      }
    </div>
  }

  <!-- Pagination (always stable - skeleton count keeps layout height constant) -->
  @if ((dataSource().hasEverLoaded ?? false) || dataSource().loading) {
    <umss-pagination
      [currentPage]="dataSource().currentPage"
      [totalPages]="totalPages()"
      [skeleton]="!(dataSource().hasEverLoaded ?? false)"
      (pageChangeStart)="onPageChangeStart()"
      (pageChange)="onPageChange($event)"
    />
  }
</div>
